import React from 'react';

const SvgPicColon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M17.34 21.1q2.88 0 4.41-1.02a4.4 4.4 0 001.92-3.14q-.32.07-.83.07a5.3 5.3 0 01-3.9-1.6 5.7 5.7 0 01-1.54-4.04q0-2.24 1.54-3.77a5.3 5.3 0 013.9-1.6q2.74 0 4.42 2.05 1.66 2.04 1.66 5.44 0 5.31-2.75 8.76-2.7 3.45-8.83 3.46zM3 21.1q2.89 0 4.42-1.02a4.4 4.4 0 001.92-3.14q-.33.07-.84.07a5.3 5.3 0 01-3.9-1.6 5.7 5.7 0 01-1.54-4.04q0-2.24 1.54-3.77A5.3 5.3 0 018.5 6q2.76 0 4.42 2.05t1.66 5.44q0 5.31-2.75 8.76Q9.15 25.7 3 25.71z" />
  </svg>
);

export default SvgPicColon;
